import React, { useEffect } from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../../widget/common/ui/MainContainer";
import SettingsAccountVericationButtons from "./widget/SettingsAccountVericationButtons";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import SettingsAccountVericationContent from "./SettingsAccountVericationContent";
import { SettingsAccountVerificationContextProvider } from "../../../../provider/settings/security/account_verification/SettingsAccountVerificationContextProvider";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";
import StorageKeys from "../../../../const/StorageKeys";
import SessionStorage from "../../../../service/storage/SessionStorage";

const SettingsAccountVericationScreen = () => {
  const type: number = ResponsiveDeviceType();

  const checkVericationSession = () => {
    const verificationSession = SessionStorage.getValue(
      StorageKeys.settings_verification_detail
    );
    if (UtilityHelper.isEmpty(verificationSession)) {
      navigate(appRoutes.routeNameSettings, { replace: true });
    }
  };

  useEffect(() => {
    checkVericationSession();
  }, []);

  return (
    <SettingsAccountVerificationContextProvider>
      <Scaffold
        appBarTitle={AppTranslation.text("account_verification")}
        bottomNavigationButton={<SettingsAccountVericationButtons />}
      >
        <MainBodyContainer>
          <SettingsAccountVericationContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </SettingsAccountVerificationContextProvider>
  );
};

export default SettingsAccountVericationScreen;
export const routeName: string = "/settings/account-verification";
